import api from "./api";
import { toSearchFilter } from "utils";
import { API_URL_VERSION } from "../constants/environment";

export const ENDPOINT_PERMITTEES = API_URL_VERSION + 'permissionarios'
export const ENDPOINT_PERMITTEES_LIST = ENDPOINT_PERMITTEES + "/listar";
export const ENDPOINT_PERMITTEES_LICENSES_BATCH_PRINT = ENDPOINT_PERMITTEES + "/imprimir-alvaras-lote";
export const ENDPOINT_PERMITTEES_LICENSES_BATCH_PRINT_BY_CODE = ENDPOINT_PERMITTEES + "/imprimir-documentos-by-codigo";
export const ENDPOINT_PERMITTEES_GET_DETAIL_UPDATE_DELETE = API_URL_VERSION + 'permissionarios/'
export const ENDPOINT_PERMITTEES_EXPORT = ENDPOINT_PERMITTEES + "/exportar";
export const ENDPOINT_PERMITTEES_PRINT_BATCH = ENDPOINT_PERMITTEES + "/imprimir-documentos-lote";
export const ENDPOINT_PERMITTEES_DETAIL = ENDPOINT_PERMITTEES_GET_DETAIL_UPDATE_DELETE + "detail/";
export const ENDPOINT_PERMITTEES_ATTACHMENT = ENDPOINT_PERMITTEES + "/foto"
export const ENDPOINT_PERMITTEES_DELETE_ATTACHMENT = ENDPOINT_PERMITTEES + "/remover-foto"


export const GenderList = {
  MALE: {value: "M", labelKey: "male"},
  FEMALE: {value: "F", labelKey: "female"},
  OTHER: {value: "N", labelKey: "other"}
}

export const permitteesService = {
    list: async (params = {}) => {
        try {
          const response = await api.post(ENDPOINT_PERMITTEES_LIST, toSearchFilter(params));
          return response.data;
        } catch (error) {
          throw error.response?.data?.message || "permittees.messages.errors.list";
        }
      },

    detail: async (id) => {
      try {
        const response = await api.get(`${ENDPOINT_PERMITTEES_DETAIL}${id}`);
        return response.data;
      } catch (error) {
        throw error.response?.data?.message || "permittees.messages.errors.find";
      }
    },

    create: async (data) => {
      try {
        const response = await api.post(ENDPOINT_PERMITTEES, data);
        return response.data;
      } catch (error) {
        throw error.response?.data?.message || error.response?.data?.erros_validacao || "permittees.messages.errors.create";
      }
    },

    find: async (id) => {
      try {
        const response = await api.get(`${ENDPOINT_PERMITTEES}/${id}`);
        return response.data;
      } catch (error) {
        throw error.response?.data?.message || "permittees.messages.errors.find";
      }
    },

    update: async (id, data) => {
      try {
        const response = await api.put(`${ENDPOINT_PERMITTEES}/${id}`, data);
        return response.data;
      } catch (error) {
        throw error.response?.data?.message || error.response?.data?.erros_validacao || "permittees.messages.errors.update";
      }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`${ENDPOINT_PERMITTEES}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "permittees.messages.errors.delete";
        }
    },

    updateStatus: async (id) => {
      try {
          const response = await api.patch(`${ENDPOINT_PERMITTEES}/${id}`);
          return response.data;
      } catch (error) {
          throw error.response?.data?.message || "permittees.messages.errors.update-status";
      }
    },

    export: async (params = {}) => {
      try {
        const response = await api.get(ENDPOINT_PERMITTEES_EXPORT, {
          responseType: 'blob',
          params: params
        });
        return response;
      } catch (error) {
        throw error.response?.data?.message || "system.messages.errors.export";
      }
    },

    printLicenseBatchList: async (params = {}) => {
      try {
        const response = await api.post(ENDPOINT_PERMITTEES_LICENSES_BATCH_PRINT, toSearchFilter(params));
        return response.data;
      } catch (error) {
        throw error.response?.data?.message || "permittees.messages.errors.list";
      }
    },
    
    printDocumentBatchList: async (params) => {
          try {
              const response = await api.post(ENDPOINT_PERMITTEES_PRINT_BATCH, toSearchFilter(params));
              return response.data;
          } catch (error) {
              throw error.response?.data?.message || "permittees.messages.errors.update-status";
          }
    },

    fetchDocumentsByCodeList: async (codes = []) => {
        try {
            const response = await api.post(ENDPOINT_PERMITTEES_LICENSES_BATCH_PRINT_BY_CODE, codes);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "permittees.messages.errors.find";
        }
    },

    attachment: async (id) => {
      try {
        const response = await api.get(`${ENDPOINT_PERMITTEES_ATTACHMENT}/${id}`, {
          responseType: 'blob'
        });
        return response.data;
      } catch (error) {
        const status = error?.response?.status;
        if (status === 404 || status === 400) return null;
        throw error.response?.data?.message || "permittees.messages.messages.errors.find-attachment";
      }
    },
  
    removeAttachment: async (id) => {
      try {
        const response = await api.delete(`${ENDPOINT_PERMITTEES_DELETE_ATTACHMENT}/${id}`);
        return response.data;
      } catch (error) {
        throw error.response?.data?.message || "permittees.messages.errors.remove-attachment";
      }
    },
};

export const PERMITTEES_TYPES = {
  "TAXI": "Táxi",
  "MOTOTAXI": "Mototáxi",
  "TRANSPORTE ESCOLAR": "Transporte Escolar",
  "ONIBUS": "Ônibus",
  "TURISMO": "Turismo"
};

export const PERMITTEES_INSPECTION_STATUS = {
  REJECTED: "Vistorias Reprovadas",
  ACCEPTED: "Vistorias Aprovadas"
};
